import { useEffect, useState } from 'react';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import { adsMemberApi } from '../../api/adsMemberApi';

export default function CampaignBillingCard({ campaignId }) {
  const { t } = useTravelTranslation();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');

    adsMemberApi.billing
      .get(campaignId)
      .then((data) => {
        if (active) {
          setBilling(data);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (active) {
          setError(err?.message || '載入帳務資料失敗');
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [campaignId]);

  if (loading) {
    return (
      <section className="ads-detail-section" data-testid="campaign-billing-loading">
        <h4 className="ads-detail-section__title">{t('travel.ads.billing.title')}</h4>
        <div className="ads-loading">{t('travel.ads.common.loading')}</div>
      </section>
    );
  }

  if (error) {
    return (
      <section className="ads-detail-section" data-testid="campaign-billing-error">
        <h4 className="ads-detail-section__title">{t('travel.ads.billing.title')}</h4>
        <div className="ads-alert ads-alert--error">{error}</div>
      </section>
    );
  }

  const budget = billing?.budget_amount ?? 0;
  const currency = billing?.currency || billing?.budgetCurrency || 'TWD';
  const reserved = billing?.reserved_amount ?? 0;
  const paid = billing?.paid_amount ?? 0;
  const isHold = Boolean(billing?.billing_hold);
  const holdReason = billing?.hold_reason;

  return (
    <section className="ads-detail-section" data-testid="campaign-billing-card">
      <h4 className="ads-detail-section__title">{t('travel.ads.billing.title')}</h4>
      {isHold ? (
        <div className="ads-alert ads-alert--notice" data-testid="billing-hold-alert">
          <strong>{t('travel.ads.billing.hold')}：{t('travel.ads.billing.held')}</strong>
          {holdReason ? <span>({holdReason})</span> : null}
        </div>
      ) : null}
      <div className="ads-grid-3">
        <div className="ads-metric">
          <div className="ads-metric__label">{t('travel.ads.billing.budget')}</div>
          <div className="ads-metric__value" data-testid="billing-budget">
            {budget} {currency}
          </div>
        </div>
        <div className="ads-metric">
          <div className="ads-metric__label">{t('travel.ads.billing.reserved')}</div>
          <div className="ads-metric__value" data-testid="billing-reserved">
            {reserved} {currency}
          </div>
        </div>
        <div className="ads-metric">
          <div className="ads-metric__label">{t('travel.ads.billing.paid')}</div>
          <div className="ads-metric__value" data-testid="billing-paid">
            {paid} {currency}
          </div>
        </div>
      </div>
    </section>
  );
}
